export default function HotelIcon() {
  return (
    <img src="https://a0.muscache.com/pictures/64b27fed-56a1-4f03-950a-d8da08efb428.jpg"
    className="w-8 h-8"
    ></img>
  );
}
